import React from 'react';
import SideNavBar from '../components/layout/SideNavBar';
import Footer from '../components/ui-kit/layout/Footer';
import InformationBar from '../components/layout/InformationBar';
import TopNav from '../components/layout/TopNav';
import DefaultHead from '../components/layout/DefaultHead';
import SeoHead from '../components/_general/seo/SeoHead';
import { Seo } from '../models/Seo';

type Props = {
	children: React.ReactNode
	title?: string,
	description?: string,
	image?: string,
	search?: boolean,
	fluid?: boolean,
	seo: Seo
}

const BaseLayout = ({ children, title, seo, search, fluid }: Props) => {
	return (
		<>
			<DefaultHead />
			<SeoHead seo={seo}/>
			<div className="flex flex-col h-screen w-full bg-theme-light-bg dark:bg-theme-dark-bg">
				<div className="flex flex-grow">
					<SideNavBar />
					<main className="flex-1 dark:bg-theme-dark-bg">
						{fluid
							? children
							: <>
								<TopNav title={title} search={search} />
								<section className="px-4 pt-20 lg:pt-0 lg:px-8">{children}</section>
							</>
						}
					</main>
					<InformationBar />
				</div>
				<Footer />
			</div>
		</>
	)
}

export default BaseLayout
